import Button from '@mui/material/Button';

function Search() {
  return (
    <div className="col-4 search">
      <form className="d-flex">
        <input
          className="form-control me-2 nav-search-input"
          type="search"
          placeholder="Search"
          aria-label="Search"
        />
        <Button className="cfa-search-btn" variant="text">
          Search
        </Button>
      </form>
    </div>
  );
}

export default Search;
